/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { forwardRef } from 'react';
import proptypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';

const { node } = proptypes;

/**
 * A thin wrapper around the Stencil Link component. All props from Link are accessible except for `component`
 * which has been set to `"span"` for accessibility.
 */
export const LinkDisplay = forwardRef(({ children, ...rest }, ref) => {
  return (
    <Link
      component="span"
      ref={ref}
      {...rest}
    >
      {children}
    </Link>
  );
});

LinkDisplay.displayName = 'LinkDisplay';

LinkDisplay.propTypes = {
  children: node
};

LinkDisplay.defaultProps = {
  children: null
};
